import axios from 'axios';
import { PaymentMethodRequest, SetupIntentPaymentMethodRequest } from '../../structures/requests/paymentMethod';
import { PaymentMethod, SetupIntentData } from '../../structures/models/paymentMethod';
import Routes from '../routes';

export const getPaymentMethods = async (): Promise<PaymentMethod[]> => {
  const response = await axios.get(
    Routes.API_PAYMENT_PROFILE,
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export const createPaymentMethod = async (
  request: SetupIntentPaymentMethodRequest,
): Promise<PaymentMethod> => {
  const response = await axios.post(
    Routes.API_PAYMENT_PROFILE,
    request,
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export const updatePaymentMethod = async (
  request: PaymentMethodRequest,
  paymentMethodId: string,
): Promise<PaymentMethod> => {
  const response = await axios.post(
    Routes.apiPaymentProfileUpdate(paymentMethodId),
    request,
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export const deletePaymentMethod = async (paymentMethodId: string): Promise<PaymentMethod> => {
  const response = await axios.delete(
    Routes.apiPaymentProfileDelete(paymentMethodId),
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export const fetchClientSecret = async (): Promise<SetupIntentData> => {
  const response = await axios.get(
    Routes.API_GET_STRIPE_CLIENT_SECRET,
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export const cancelSetupIntent = async (
  stripeSetupIntentId: string,
): Promise<{ data: [], errors: string[] }> => {
  const response = await axios.post(
    Routes.API_CANCEL_STRIPE_SETUP_INTENT,
    {
      stripe_setup_intent_id: stripeSetupIntentId,
    },
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (response.data.errors && response.data.errors.length > 0) {
    throw response.data.errors;
  }

  return response.data.data;
};

export default {
  create: createPaymentMethod,
  index: getPaymentMethods,
  update: updatePaymentMethod,
  delete: deletePaymentMethod,
  fetchClientSecret,
  cancelSetupIntent,
};
